<template>
	<div class="documentate">
		<div class="content">
			
			<div class="datacon">
				<div class="l_c">
					<tiplist :title="'文件资料'" sign="5" :list='info' len='30'></tiplist>
				</div>
				<div class="r_c">
					<tiplist :title="'预决算公开'" sign="11" :list='openInfo' len='30'></tiplist>
				</div>
			</div>
			
			<div class="research">
				<research :list='youthCentre' len='7'></research>
			</div>
			
		</div>
		
	</div>
	
</template>

<script>

import tiplist from '@/components/helppart/tiplist.vue'
import research from '@/components/helppart/research.vue'
export default {
  components:{tiplist,research}, 
  data: function() {
		return {
		  info:[],
		  openInfo:[],
		  youthCentre:[],
		};
  },
  
  created() {
	this.init();
  },

  methods: {
	init(){
		this.getInfo();
		this.getOpenInfo();
		this.getYouthCentre()
	},
   	getInfo(){//文件资料
		var param={
			pageNo:1,
			pageSize:6,
			// msgType:13
			msgType:20
		}
		this.$get('/web/information/list',param).then(res=>{ 
			this.info=res.result.records;
		})
	},
	getOpenInfo(){//预决算公开
		var param={
			pageNo:1,
			pageSize:6,
			msgType: 16
		}
		this.$get('/web/information/list',param).then(res=>{ 
			this.openInfo=res.result.records;
		})
	},
	getYouthCentre(){//青海青少年研究youthCentre
		var param={
			pageNo:1,
			pageSize:6,
			msgType:18
		}
		this.$get('/web/information/list',param).then(res=>{ 
			this.youthCentre=res.result.records;
		})
	},
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.documentate{
	width: 1200px;
	position: relative;
	left: 50%;
	transform: translateX(-50%);
	height: 100%;
	background: #ffffff;
	.content{
		min-height: 200px;
	    padding: 40px 20px 40px 20px;
		.datacon{
			display: flex;
			.l_c{
				flex: 1;
				margin-right: 15px;
			}
			.r_c{
				flex: 1;
				margin-left: 15px;
			}
		}
		
		.research{
			margin-top: 40px;
			
		}
		
		
		
	}
	
}

</style>
